import { render, staticRenderFns } from "./Func53Novo.vue?vue&type=template&id=5054d157"
import script from "./Func53Novo.vue?vue&type=script&lang=js"
export * from "./Func53Novo.vue?vue&type=script&lang=js"
import style0 from "./Func53Novo.vue?vue&type=style&index=0&id=5054d157&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports